export default __webpack_public_path__ + "static/media/easyfmm_logo.c0ecc5e1.png";